import { PdInputTime } from "./pd-input-time/PdInputTime.js";
//#region src/pd-input-time/pd-input-time.ts
var tag = "pd-input-time";
if (!customElements.get(tag)) customElements.define(tag, PdInputTime);
//#endregion
export { PdInputTime };
